import {
    FETCH_PROCEDURES_LIST_REQUEST,
    FETCH_PROCEDURES_LIST_SUCCESS,
    FETCH_PROCEDURES_LIST_FAILURE,
  } from "./FetchProceduresListTypes";
  
  const initialState = {
    loading: false,
    proceduresList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PROCEDURES_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_PROCEDURES_LIST_SUCCESS:
        return {
          loading: false,
          proceduresList: action.payload,
          error: "",
        };
      case FETCH_PROCEDURES_LIST_FAILURE:
        return {
          loading: false,
          proceduresList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  